<template>
  <div class="side-info">
    <div class="header">
      <p>{{ name }}</p>
      <p :class="{ 'green-text': signStatus, 'orange-text': !signStatus }">
        {{ signStatus ? 'ПОДПИСАЛ ДОГОВОР' : 'ИЗУЧАЕТ ДОГОВОР' }}
      </p>
    </div>
    <p class="phone-box phone">
      {{ isMine ? dataStore.contractInfo.client_phone : '' }}
    </p>
    <div v-if="isMine && !signStatus" class="sign-code-container">
      <Button
        v-if="showCodeBtn"
        :disabled="dataStore.contractInfo.code_sended"
        @click="getSignCode()"
        >Подписать договор*</Button
      >
      <p v-if="showCodeBtn">
        * После нажатия на кнопку на номер
        <span class="phone">
          {{ dataStore.contractInfo.phone || dataStore.contractInfo.client_phone }}
        </span>
        будет выслан код подтверждения
      </p>
      <CodeInput v-if="dataStore.contractInfo.code_sended" @code-input-end="handleCodeInputEnd" />
      <a v-if="dataStore.contractInfo.code_sended" href="#" @click="getSignCode()"
        >Отправить код повторно</a
      >
    </div>
  </div>
</template>
<script setup>
import api from '@/api'
import Button from './inputs/Button.vue'
import CodeInput from './inputs/CodeInput.vue'
import { computed, inject } from 'vue'
import { useDataStore } from '@/stores/dataStore'
const props = defineProps({
  isMine: {
    type: Boolean,
    required: true
  }
})
const dataStore = useDataStore()

const showCodeBtn = computed(() => {
  return !dataStore.contractInfo.code_sended
})

const signStatus = computed(() => {
  return props.isMine ? dataStore.contractInfo.signed_doc_hash : true
})

const name = computed(() => {
  return !props.isMine ? dataStore.contractInfo.organization?.name : dataStore.contractInfo.name
})

const showError = inject('showError')

async function getSignCode() {
  try {
    const response = await api.get('/signCode/' + dataStore.contractInfo.uuid)
    if (response.status !== 200) {
      showError(response.data)
      return
    }
    dataStore.contractInfo.code_sended = true
    console.log(response.data)
  } catch (error) {
    console.log(error)
    showError(error.response?.data || error)
  }
}

async function handleCodeInputEnd(code) {
  try {
    const response = await api.post('/sign', { uuid: dataStore.contractInfo.uuid, code })
    if (response.status !== 200) {
      showError(response.data)
      return
    }
    location.reload()
    console.log(response.data)
  } catch (error) {
    showError(error.response?.data || error)
  }
}
</script>
<style scoped>
.sign-code-container {
  gap: 10px;
  display: flex;
  flex-direction: column;
}
.side-info {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: var(--base-gap);
  border-radius: var(--base-border-radius);
  padding: var(--base-padding);
  background: #fff;
}
.header {
  display: flex;
  gap: 10px;
}
.green-text {
  color: #27ae60;
}
.orange-text {
  color: #cfa600;
}
.phone-box {
  color: #525252;
  padding: 10px;
}
.phone {
  font-family: monospace;
}
</style>
